module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce.ttf?db33e7676b65cdbfddbe8cdce17ca068";